import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-object-dropdown',
  templateUrl: './object-dropdown.component.html',
  styleUrls: ['../dropdown.component.scss']
})
export class ObjectDropdownComponent implements OnInit {
  @Input() options: Array<any>;
  @Input() title: string;
  @Input() parentForm: FormGroup;
  @Input() parentControl: string;
  @Input() valueKey: string;
  @Input() displayKey: string;
  @Input() showAll: boolean;
  @Input() isDisabled: boolean;
  isDropDown: boolean;
  activeTitle: string;

  ngOnInit(): void {
    this.activeTitle = this.title;
  }

  onToggle(): void {
    this.isDropDown = !this.isDropDown;
  }

  getDisplayValue(): string {
    const val = this.f[this.parentControl].value;
    if (val === '' || val === null || val === undefined) return this.activeTitle || 'Izaberi';
    const option = this.options?.find(o => o[this.valueKey] === val);
    return option ? option[this.displayKey] : this.activeTitle || 'Izaberi';
  }

  trackByFunction(index: number): number {
    return index;
  }

  get f() {
    return this.parentForm.controls;
  }
}
